import styled from 'styled-components';

import { getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

export const PriceContainer = styled.div`
    display: flex;
    margin-top: ${getPurpurSpacing('250')};
    margin-bottom: ${getPurpurSpacing('250')};
    align-items: baseline;
    column-gap: ${getPurpurSpacing('400')};
    flex-wrap: wrap;
`;

export const PriceBig = styled.span`
    font-size: 1.625rem;
    font-weight: ${getPurpurTypography('weightBold')};
`;

export const PriceResidual = styled.div`
    display: inline-block;
    font-size: ${getPurpurTypography('scale100')};
    margin-left: ${getPurpurSpacing('400')};
`;

export const PriceCurrency = styled.span`
    font-size: ${getPurpurTypography('scale100')};
    font-weight: ${getPurpurTypography('weightNormal')};
`;

export const PriceOldPrice = styled.span`
    margin-left: ${getPurpurSpacing('100')};
    text-decoration: line-through;
    color: rgba(34, 34, 34, 0.64);
    font-size: ${getPurpurTypography('scale100')};
    font-weight: ${getPurpurTypography('weightNormal')};
`;
